/**
 * Je to ještě první zobrazená stránka (vstup na web), nebo už návštěvník
 * přešel jinam?
 *
 * Na první stránce nesmí vstupní animace obsah schovat: HTML z prerenderu je
 * vidět hned, React ho ale při startu vykreslí znovu a animace z opacity 0 by
 * obsah na zlomek sekundy skryla. Prohlížeč pak nadpis ani text v hero
 * nepočítá jako „největší vykreslený obsah" (LCP) a za LCP vezme až cookie
 * lištu o několik sekund později (Lighthouse mobil: LCP 6,6 s).
 * Po přechodu na další stránku se animace chovají jako dřív.
 */
const initialPath = typeof window !== 'undefined' ? window.location.pathname : '';
let navigated = false;

export function isInitialView(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  if (!navigated && pathname !== initialPath) navigated = true;
  return !navigated;
}
